module.exports = __webpack_public_path__ + "img/tick_mark.d76baf05.svg";